import React from "react";
import { ItemsTable } from "./ReorderPage";

export default function SlowPage() {
  const columns = [
    { key: "sku", label: "SKU", mono: true },
    { key: "brand", label: "Brand" },
    { key: "tire_size", label: "Size", mono: true },
    { key: "quantity_on_hand", label: "QOH", mono: true, align: "right" },
    { key: "cost", label: "Unit Cost", mono: true, align: "right", render: (r) => r.cost ? `$${r.cost.toFixed(2)}` : "—" },
    { key: "capital_tied_up", label: "Capital", mono: true, align: "right", render: (r) => `$${(r.capital_tied_up || 0).toFixed(2)}` },
    { key: "units_sold", label: "Units Sold (window)", mono: true, align: "right" },
    { key: "days_since_sale", label: "Days Since Sale", mono: true, align: "right", render: (r) => r.days_since_sale ?? "—" },
    { key: "recommendation_reason", label: "Why", render: (r) => <span className="text-xs text-[#3B424B]">{r.recommendation_reason}</span> },
  ];
  return <ItemsTable view="slow" columns={columns} emptyMsg="No slow inventory identified in the current window." testid="slow" />;
}
